import React  from 'react';
import { Grid, Typography } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { errorsFormRegisterState } from '../../state/atoms';
import PasswordField from '../../components/PasswordField';
import PasswordRepeatField from '../../components/PasswordRepeatField';
import RulesPasswordCreate from '../../components/RulesPasswordCreate';

const FormCreatePassword = () => {
    const { matchPassword } = useRecoilValue(errorsFormRegisterState);
    return (
        <>
            <Grid container spacing={2}>
                <Grid item md={6} xs={12}>
                    <PasswordField />
                </Grid>

                <Grid item md={6} xs={12}>
                    <PasswordRepeatField />
                </Grid>

                {
                    matchPassword.length > 0 && (
                        <Grid item xs={12} md={12} display={"flex"} justifyContent={"center"}>
                            <Typography color="error" fontSize={"0.75rem"}>{matchPassword.join("\n")}</Typography>
                        </Grid>
                    )
                }

            </Grid>
            <Grid container mt={2}>
                <Grid item xs={12} md={12}>
                    <RulesPasswordCreate />
                </Grid>
            </Grid>
        </>
    )
}

export default FormCreatePassword;